(() => {
  // Affiche le résumé 5/5 · 10 000 avis lorsque le produit n'a pas encore
  // de métadonnées d'avis réelles. Les vrais avis restent prioritaires.
  const showPreviewRatings = () => {
    document.querySelectorAll('[data-sn59-preview-rating]').forEach((container) => {
      const template = container.querySelector('template');
      if (template) container.replaceChildren(template.content.cloneNode(true));
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showPreviewRatings, { once: true });
  } else {
    showPreviewRatings();
  }
  document.addEventListener('shopify:section:load', showPreviewRatings);
})();